import "./Testimonials.scss";
import WebLayout from "../../components/webLayout/WebLayout";
import { testimonial } from "../../utils/testimonial";
import TestimonialCard from "../../components/testimonialCard/TestimonialCard";
import { Fragment } from "react";

const Testimonials = () => {
  return (
    <WebLayout>
      <section className="testimonial_page">
        <div className="content_wrap pt-5 p_b">
          <h2 className="pt-4">Testimonials</h2>
          <div className="testimonials_grid">
            {testimonial?.map((data, j) => {
              return (
                <Fragment key={j}>
                  <TestimonialCard data={data} index={2} active={1} />
                </Fragment>
              );
            })}
          </div>
        </div>
      </section>
    </WebLayout>
  );
};

export default Testimonials;
